<template>
    <div class="form-page">
        <my-form v-model="form" readonly table>
            <my-form-item-group title="异议或投诉信息">
                <el-form-item label="投诉单位" prop="tsdwname" class="table-full-row">
                    {{form.tsdwname||'-'}}
                </el-form-item>
                 <el-form-item label="提交时间" class="table-full-row">
                    {{form.tjtime||'-'}}
                </el-form-item>
                <el-form-item label="投诉内容" prop="tscontent"  class="table-full-row">
                    {{form.tscontent||'-'}}
                </el-form-item>
                <el-form-item label="理由依据" prop="lyyj"  class="table-full-row">
                    {{form.lyyj||'-'}}
                </el-form-item>
               
               <el-form-item label="附件" class="table-full-row">
                    <my-upload readonly  :file-guid="form.fileguid"></my-upload>
                </el-form-item> 
            </my-form-item-group>
            <my-form-item-group title="受理异议或投诉信息">
                <el-form-item label="投诉受理人" prop="tsslr" class="table-full-row">
                    {{form.tsslr||'-'}}
                </el-form-item>
                <el-form-item label="受理时间" class="table-full-row">
                    {{form.sltime||'-'}}
                </el-form-item>
                 <el-form-item label="处理结果" prop="by4"  class="table-full-row">
                     <el-input v-html="form.clresult||'-'" type="textarea"></el-input>
                </el-form-item>
                 <el-form-item label="附件" class="table-full-row">
                    <my-upload readonly  :file-guid="form.by5"></my-upload>
                </el-form-item> 
            </my-form-item-group>
        </my-form>
    </div>
</template>
     
<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            form:{}
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {


    },
    created() {
         this.$get(`${this.getGetters('bidUrl')}/bidding/yygl/tsdetail.json`, {
            id:this.getQuery('id'),
            procode:this.getQuery('procode'),
        }, data => {
            this.form=data.model;
        });
        
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
